module.exports = __webpack_public_path__ + "static/media/Rita Cornwell Alcove units.30206880.JPG";